import axios from "axios";
import { useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ActionTypes } from "../store/types";
import { emailRegEx } from "../utils/regex";
import WithMotion from "../utils/withMotion";

import { Slider } from "../components/Slider";
import scss from "./SignUp.module.scss";
import Checkbox from "react-custom-checkbox";
import checkmark from "../assets/check.png";

export const SignUp = () => {
  const { squadSubmission } = useSelector((state: any) => state);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [terms, setTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  if (squadSubmission) {
    return <Redirect to="/your-squad" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!(name && emailRegEx.test(email))) {
      setError("Please provide your name and a valid email address");
      return;
    }
    if (!terms) {
      setError(
        "Please agree to the Official Rules, Terms of Use, and Privacy Policy"
      );
      return;
    }
    setLoading(true);

    await axios
      .get(`/get_email_check?email=${email}`)
      .then(({ data }) => {
        if (data.errorMessage) {
          setError(data.errorMessage);
          setLoading(false);
        } else {
          dispatch({
            type: ActionTypes.SET_USER,
            payload: { name, email, terms },
          });
          dispatch({
            type: ActionTypes.SET_SQUAD_SUBMISSION,
            payload: { squadSubmission: null },
          });
          history.push("/sign-up-theater");
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setError(err.response?.data?.errorMessage);
      });
  };

  return (
    <main className={scss.main}>
      <h2 className={scss.instruction}>
        Enter The sweepstakes
        <br />
        and then we’ll pick
        <br />
        some DC super-villains
      </h2>
      <Slider step={0} />
      <form className={scss.inputContainer} onSubmit={handleSubmit}>
        <label>
          Name
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <label>
          Email
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label className={scss.agreement}>
          <Checkbox
            name="Terms"
            id="Terms"
            checked={terms}
            onChange={(value) => setTerms(value)}
            icon={<img src={checkmark} alt="check" />}
            style={{
              cursor: "pointer",
              padding: "2px",
            }}
            borderColor={"#418BFA"}
            borderRadius={0}
          />
          <p>
            By checking this box, you agree to the{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.imax.com/content/squad-rules"
            >
              Official Rules
            </a>
            ,{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.imax.com/content/terms-service"
            >
              Terms of Use
            </a>
            , and{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.imax.com/content/privacy-policy"
            >
              Privacy Policy
            </a>
          </p>
        </label>

        <button
          disabled={loading}
          onClick={handleSubmit}
          className="roundedButton"
        >
          {loading ? "LOADING..." : "NEXT"}
        </button>
        <p className={scss.error}>{error}</p>
        <p className={scss.sweepsTerms}>
          <b>NO PURCHASE NECESSARY.</b> Ends 11:59 pm PT on August 9, 2021. Open
          only to United States; 17+. 10 prizes are available to be won (ARV: US
          $84.99). Entries will not be judged. Winner will be randomly selected.
          Rules/odds/alt. method of entry:{" "}
          <span>
            <a
              className={scss.blueLink}
              href="https://www.imax.com/content/squad-rules"
              target="_blank"
              rel="noreferrer"
            >
              Official Rules
            </a>
          </span>
        </p>
      </form>
    </main>
  );
};

export default WithMotion(SignUp);
